<template>
  <AutoPassTable data-testid="auto-pass-table" />
</template>
<script>
import AutoPassTable from "@/v3components/Datatables/AutoPassTable.vue"
export default {
  name: "AutoPass",
  components: { AutoPassTable }
}
</script>
